import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {Collapse, useMediaQuery} from '@mui/material'
import CardAtom from '../../@atoms/to_layout/card/card.atom'
import CardVisitHeaderComponent from './card_visit_sections/card_visit_header.component'
import CardVisitDetailAtom from '../../@atoms/to_content/card_visit_detail/card_visit_detail.atom'
import ContactDetailsComponent from './card_visit_sections/contact_details.component'
import HereMapsComponent from '../here_maps/here_maps.component'
import OrderStatusComponent from './card_visit_sections/order_status.component'
import ProductListComponent from './card_visit_sections/product_list.component'
import SkeletonAtom from '../../@atoms/to_layout/skeleton/skeleton.atom'
import {RootState} from '../../store_redux'
import {OrderType} from '../../props_reusable/order_details'
import {Visit} from '../../props_reusable/visit'
import utils from '../../utils'
import {fetchAllVisits} from '../../store_redux/reducer/order_details.reducer'

export interface VisitProps {
  visit: Visit
  orderType?: OrderType
}

interface VisitDetailProps extends VisitProps {
  expand: boolean
}

export interface VisitActionProps {
  expanded: boolean
  setExpanded: (v: boolean) => void
}

const VisitDetail: React.FC<VisitDetailProps> = function ({visit, expand}) {
  const settings = useSelector((state: RootState) => state.settings)
  const matches = useMediaQuery('(min-width:481px)')
  const [expanded, setExpanded] = useState(expand)
  const {isMapVisible, setAddress} = settings
  const isAddressSectionVisible = setAddress !== 'none'
  const {coordinate} = visit

  return (
    <CardAtom ap_type="visit_details" variant="outlined">
      <CardVisitHeaderComponent
        expanded={expanded}
        setExpanded={setExpanded}
        visit={visit}
      />
      <OrderStatusComponent expanded={expanded} visit={visit} />
      <Collapse in={expanded} timeout="auto">
        {matches && isMapVisible && isAddressSectionVisible && (
          <HereMapsComponent
            ap_latitude={coordinate?.latitude}
            ap_longitude={coordinate?.longitude}
            ap_isCoordinateFromPostCodeLookup={coordinate?.isCoordinateFromPostCodeLookup}
          />
        )}
        <ContactDetailsComponent {...visit} />
        <ProductListComponent {...visit} />
      </Collapse>
    </CardAtom>
  )
}

const CardVisitDetailsComponent = function () {
  const rootState = useSelector((state: RootState) => state)
  const dispatch = useDispatch()
  const {orderDetails, settings, labels} = rootState
  const isLabelEmpty = utils.isObjectEmpty(labels)
  const isSettingsEmpty = utils.isObjectEmpty(settings)
  const headerDetails = orderDetails.header.data
  const visits = orderDetails.visits.data

  const isDataAvailable =
    !!visits && !!headerDetails?.orderType && !isLabelEmpty && !isSettingsEmpty

  useEffect(() => {
    dispatch(fetchAllVisits())
    // eslint-disable-next-line
  }, [])

  const getExpand = (i: number) => {
    switch (settings.expandVisitCard) {
      case 'all':
        return true
      case 'first':
        return i === 0
      default:
        return false
    }
  }

  if (!isLabelEmpty && (orderDetails.visits.error || orderDetails.header.error))
    return null

  return (
    <CardVisitDetailAtom>
      {isDataAvailable ? (
        visits.map((v, i) => (
          <VisitDetail key={v.visitNumber} visit={v} expand={getExpand(i)} />
        ))
      ) : (
        <SkeletonAtom ap_type="visit_card_skeleton" />
      )}
    </CardVisitDetailAtom>
  )
}

export default CardVisitDetailsComponent
